import pagination from '../../utils/pagination'
import {
  SUPPLY_RETURNS_BATCH_DELETE_REQUEST, SUPPLY_RETURNS_BATCH_DELETE_SUCCESS, SUPPLY_RETURNS_BATCH_DELETE_FAILURE,
  SUPPLY_RETURNS_FETCH_MANY_REQUEST, SUPPLY_RETURNS_FETCH_MANY_SUCCESS, SUPPLY_RETURNS_FETCH_MANY_FAILURE,
  SUPPLY_RETURNS_FETCH_REQUEST, SUPPLY_RETURNS_FETCH_SUCCESS, SUPPLY_RETURNS_FETCH_FAILURE,
  SUPPLY_RETURNS_SAVE_REQUEST, SUPPLY_RETURNS_SAVE_SUCCESS, SUPPLY_RETURNS_SAVE_FAILURE,
  EMPTY_SUPPLY_RETURNS,
  CLEAR_ERRORS
} from './types'

export default {
  [SUPPLY_RETURNS_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [SUPPLY_RETURNS_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [SUPPLY_RETURNS_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [SUPPLY_RETURNS_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [SUPPLY_RETURNS_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data || []
    state.page = pagination(data)
    state.loading = false
  },
  [SUPPLY_RETURNS_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [SUPPLY_RETURNS_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [SUPPLY_RETURNS_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [SUPPLY_RETURNS_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [SUPPLY_RETURNS_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [SUPPLY_RETURNS_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [SUPPLY_RETURNS_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_SUPPLY_RETURNS] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  }
}
